// extracted by mini-css-extract-plugin
export var active = "_gb-2";
export var recordingDot = "_gb-1";
export var recordingIndicator = "_gb-0";